/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import PoaAgreementText from "@/src/components/Form/Common/PowerOfAttorney/PoaAgreementText";
import ButtonLoading from "@/src/components/Button/ButtonLoading";
import EmailVerificationModal from "@/src/components/FormInfoModal/EmailVerificationModal";
import { useForm } from "@/src/provider/Form/FormProvider";
import Signature from "@/src/components/Form/Common/Signature/Signature";
import FormSubmitProps from "@/src/types/FormSubmitProps";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { Box } from "@mui/material";
import ProductBox from "@/src/components/ProductBox/ProductBox";

type PowerOfAttorneyProps = {
  submitProps: FormSubmitProps;
  product: AbstractCase;
};
const PowerOfAttorney = ({ submitProps, product }: PowerOfAttorneyProps) => {
  const { handleSubmit } = useForm();

  return (
    <ProductBox variant={"hintbox"} headline={<strong>Vollmacht</strong>}>
      <Box component={"form"} id={"application-form"} onSubmit={handleSubmit}>
        <div>
          <p>
            Hiermit erteile ich den Legalbird Rechtsanwälten (Legalbird Rechtsanwälte Rechtsanwalts GmbH) die Vollmacht zur Vertretung meiner Interessen in
            meiner Familienrechtsangelegenheit. Die Vollmacht umfasst insbesondere die Befugnis
          </p>
          <ol>
            <li>zur Antragstellung in Scheidungs- und Scheidungsfolgesachen</li>
            <li>zum Abschluss von Vereinbarungen über Ehescheidungsfolgen</li>
            <li>zur Stellung von Anträgen auf Erteilung von Renten- und sonstigen Versorgungsauskünften</li>
          </ol>
          <p>
            Die Vollmacht umfasst auch die Befugnis, die Vollmacht ganz oder teilweise auf andere zu übertragen und die von dem Gegner, von der Justizkasse oder
            von sonstigen Stellen zu erstattenden Beträge entgegenzunehmen sowie Akteneinsicht zu nehmen.
          </p>
          <p>
            Mir ist bekannt, dass mit der Vollmacht eine Beauftragung zur Scheidung und damit eine Anwaltsvergütung entsteht, deren Höhe abhängig vom
            Verfahrenswert ist, der vom Gericht festgesetzt wird.
          </p>
          <p>Die Bearbeitung meines Mandats erfolgt vorbehaltlich der Annahme durch die {product.lawFirm.name}.</p>
          <PoaAgreementText lawFirmName={product.lawFirm.name} />
        </div>
        <Signature product={product} person={product.client} />
        <Grid
          container
          sx={{
            justifyContent: "center",
            alignItems: "baseline",
          }}
        >
          <Grid size={12}>
            <ButtonLoading
              color="primary"
              variant="contained"
              type="submit"
              fullWidth={true}
              disabled={!product.client.signature}
              isLoading={submitProps.isLoading}
            >
              Vollmacht erteilen{product.paymentType !== "insurance" && " und kostenpflichtig beauftragen"}
            </ButtonLoading>
          </Grid>
        </Grid>
      </Box>
      <EmailVerificationModal />
    </ProductBox>
  );
};

export default PowerOfAttorney;
